import { render, staticRenderFns } from "./IsardTable.vue?vue&type=template&id=f375fe42&"
import script from "./IsardTable.vue?vue&type=script&lang=js&"
export * from "./IsardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports